import { useState }  from 'react'
import axios from 'axios';
import { toast } from 'react-hot-toast';
import { getToken, getUser, getRestoLogin } from '../Utils/Common';

const postConfig = {
  headers: {
      "api-key": process.env.REACT_APP_API_KEY,
      // "Content-Type": "application/x-www-form-urlencoded",
  },
};

const postConfigFormData = {
  headers: {
      "api-key": process.env.REACT_APP_API_KEY,
      'Content-Type': 'multipart/form-data',
  },
};

export const usePostRequest = (onAfterSuccessCall=null) => {
  const [responseData, setResponseData] = useState(null);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  // const formData = new FormData();

  async function callPost(endpoint, values, isFormData=false, restoType) {
    try {
        setIsLoading(true);
        var payload = isFormData ? new FormData() : {};

        if (isFormData) {
          payload.append("requester", getUser());
          payload.append("token", getToken());

          values.forEach(data => {
            if (Array.isArray(data.value)) {
              // Check if the array contains arrays
              const hasArrays = data.value.some(item => Array.isArray(item));
              if (hasArrays) {
                // If the array contains arrays, append each sub-array as a separate parameter
                data.value.forEach((itemArray, index) => {
                  itemArray.forEach(item => {
                    payload.append(`${data.key}[${index}][]`, item);
                  });
                });
              } else {
                data.value.forEach((item) => {
                  payload.append(`${data.key}[]`, item);
                });

                // // Modification to address missing payload variables if lengths are 0
                // if (data.value && data.value.length > 0) {
                //   data.value.forEach((item) => {
                //     payload.append(`${data.key}[]`, item);
                //   });
                // } else {
                //   payload.append(`${data.key}[]`, []);
                // }
              }
            } else { 
              payload.append(data.key, data.value)
            }
          })

        } else {
          payload = {
              requester: getUser(),
              // token: getToken(),
              ...values,
          }
        }
    
          const response = restoType==="happyhippos" ? await axios.post(
            `${process.env.REACT_APP_BRIQUE_API}${endpoint}`,
            payload,
            isFormData? postConfigFormData : postConfig,
          ) : await axios.post(
            `${process.env.REACT_APP_ETTAS_API}${endpoint}`,
            payload,
            isFormData? postConfigFormData : postConfig,
          );

        // if not delete and endpoint
        if (endpoint.split('/')[1] !== 'delete') {
          if ('has_errors' in response.data) {
            if (response.data.has_errors === false) {
              toast.success("Success!")
            } else {
              response.data.errors.forEach(message => {
                toast.error(message)
              })
            }
          } else if (Array.isArray(response.data)){
            response.data.forEach(message => {
              toast.success(message)
            })
          } else {
            if (response.data.data && response.data.data.message) {
              toast.success(response.data.data.message);
            } else if (response.data.response && response.data.response.message) {
              toast.success(response.data.response.message);
            } else if (response.data.message && response.data.message.message) {
              if (response.data.status===200) {
                toast.success(response.data.message.message)
              } else {
                toast.error(response.data.message.message)
              }
            } else if (response.data.message) {
              toast.success(response.data.message);
            } else if (response.data.response) {
              toast.success(response.data.response);
            } else if (response.data.status && response.data.status===400) {
              toast.error("Validation error");
            } else if (response.message) {
              toast.success(response.message);
            } else if (response) {
              toast.success(response)
            } else {
              toast.success('Success');
            }
          }
        }

        setResponseData(response.data);
        setTimeout(()=>{
          if (endpoint.split('/')[1] === 'delete'){
            toast.success("Deleted successfully!")
          }
          onAfterSuccessCall();
        },500)

      } catch (error) {
        if (error?.response?.data?.messages?.error) {
          toast.error(error.response.data.messages.error);
        } else {
          error?.response?.data?.messages?.error_messages?.forEach(errMsg => {
            toast.error(errMsg)
          })
        }
        setError(error);
      } finally {
        setIsLoading(false);
      }
  }

  return { responseData, error, isLoading, callPost };
}

export const usePutRequest = (onAfterSuccessCall=null) => {
  const [responseData, setResponseData] = useState(null);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const restoLogin = getRestoLogin();
  // const formData = new FormData();

  async function callPut(endpoint, values, restoType) {
    try {
        setIsLoading(true);

        const payload = Object.keys(values).map((key) => {
          return {
            key: key,
            value: values[key]
          }
        })

        const params = new URLSearchParams();
        params.append('updated_by', getUser());
        params.append('token', getToken());
        // payload.forEach((row) => {
        //   params.append(row.key, row.value);
        // })
        payload.forEach(data => {
          if (Array.isArray(data.value)) {
            // Check if the array contains arrays
            const hasArrays = data.value.some(item => Array.isArray(item));
            if (hasArrays) {
              // If the array contains arrays, append each sub-array as a separate parameter
              data.value.forEach((itemArray, index) => {
                itemArray.forEach(item => {
                  params.append(`${data.key}[${index}][]`, item);
                });
              });
            } else {
              data.value.forEach((item) => {
                params.append(`${data.key}[]`, item);
              });
            }
          } else { 
            params.append(data.key, data.value)
          }
        })
    
        // const response = restoType==="happyhippos" ? await axios.put(
        //   `${process.env.REACT_APP_BRIQUE_API}${endpoint}`,
        //   params, postConfig
        // ) : await axios.put(
        //   `${process.env.REACT_APP_ETTAS_API}${endpoint}`,
        //   params, postConfig
        // ) ;

        const response = restoLogin==="happyhippos" ? await axios.put(
          `${process.env.REACT_APP_BRIQUE_API}${endpoint}`,
          params, postConfig,
        ) : await axios.put(
          `${process.env.REACT_APP_ETTAS_API}${endpoint}`,
          params, postConfig,
        );

        // if not delete and endpoint
        if (endpoint.split('/')[1] !== 'delete') {
          if ('has_errors' in response.data) {
            if (response.data.has_errors === false) {
              toast.success("Success!")
            } else {
              response.data.errors.forEach(message => {
                toast.error(message)
              })
            }
          } else if (Array.isArray(response.data)){
            response.data.forEach(message => {
              toast.success(message)
            })
          } else {
            if (response.data.data && response.data.data.message) {
              toast.success(response.data.data.message);
            } else if (response.data.response && response.data.response.message) {
              toast.success(response.data.response.message);
            } else if (response.data.message && response.data.message.message) {
              toast.success(response.data.message.message)
            } else if (response.data.message && response.data.message.success) {
              toast.success(response.data.message.success);
            } else if (response.data.message) {
              toast.success(response.data.message);
            } else if (response.data.response) {
              toast.success(response.data.response);
            } else if (response.data.status && response.data.status===400) {
              toast.error("Validation error");
            } else if (response.message) {
              toast.success(response.message);
            } else if (response) {
              toast.success(response)
            } else {
              toast.success('Success');
            }
          }
        }

        setResponseData(response.data);
        setTimeout(()=>{
          if (endpoint.split('/')[1] === 'delete'){
            toast.success("Deleted successfully!")
          }
          onAfterSuccessCall();
        },500)

      } catch (error) {
        if (error?.response?.data?.messages?.error) {
          toast.error(error.response.data.messages.error);
        } else {
          error?.response?.data?.messages?.error_messages?.forEach(errMsg => {
            toast.error(errMsg)
          })
        }
        setError(error);
      } finally {
        setIsLoading(false);
      }
  }

  return { putResponseData: responseData, error, putIsLoading: isLoading, callPut };
}
 